import * as Dialog from "@radix-ui/react-dialog";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Panel, Title } from "../../../account/account-settings.styled";

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const slideUp = keyframes`
  from { transform: translateY(12px); opacity: 0 }
  to { transform: translateY(0); opacity: 1 }
`;

export const Overlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    background: rgba(5, 7, 12, 0.55);
    z-index: 1001;
    animation: ${fadeIn} 160ms ease-out both;
    -webkit-backdrop-filter: saturate(110%) blur(1.5px);
    backdrop-filter: saturate(110%) blur(1.5px);
`;

export const ContentShell = styled(Dialog.Content)`
    position: fixed;
    inset: 0;
    z-index: 1002;
    display: grid;
    place-items: center;
    pointer-events: none;
    outline: none;
`;

export const DialogPanel = styled(Panel)`
    width: calc(100% - 32px);
    pointer-events: auto;
    animation: ${slideUp} 200ms ease-out both;

    /* scrolling for tall content */
    max-height: 90%;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const PlanCard = styled.button<{ $active?: boolean }>`
  all: unset;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;

  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  cursor: pointer;
  background: #23252a;

  ${({ $active }) =>
    $active
        ? `
    box-shadow: 0 0 0 2px #5e84ed inset;
    border-color: rgba(94,132,237,0.55);
  `
        : `
    &:hover { border-color: rgba(255,255,255,0.18); }
  `}
`;

export const PlanHeader = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
`;

export const Badge = styled.span`
    font-family: "Inter";
    font-size: 12px;
    font-weight: 500;
    color: #aab3c5;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 999px;
    width: 92px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FeatureListWrap = styled.div`
    margin-top: 12px;
`;

export const CurrentTrial = styled.div`
    font-family: Inter;
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 14px;
    line-height: 140%;
    color: #b7bdcb;
`;

/** Small helper to keep inline Title usage consistent from the main file if needed */
export const InlineTitle = Title;
